/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { message, Modal } from "antd";
import { saveAs } from "file-saver";
import {
  downLoadFileRoute,
  createByPeriodRoute,
  invoicesBulkRoute,
  createInvoiceRoute,
} from "../../lib/routes/invoices";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import Message from "../../components/Message/Message";
import { toDisplayFormat } from "../../lib/utils/formatDate";
import { getRoute } from "../../lib/routes";

const initialState = {
  createByPeriodUpload: "",
  createByPeriodUploadLoading: rtkRequestStatusCodes.idle,
  downloadFile: "",
  downloadFileLoading: rtkRequestStatusCodes.idle,
};

const deleteInvoices = createAsyncThunk(
  "invoices/deleteInvoices",
  ({ agreementId, effectiveDateFrom, effectiveDateTo }) => {
    const url = getRoute("billing-api", "invoices");
    axios
      .delete(url, {
        data: {
          agreementId,
          effectiveDateFrom,
          effectiveDateTo,
        },
      })
      .then(() => {
        Modal.success({
          title: "Задание завершено успешно",
        });
      })
      .catch(() => {
        Modal.error({
          title: "Ошибка удаления инвойсов",
        });
      });
  }
);

const handleCreateByPeriod = createAsyncThunk(
  "invoices/handleCreateByPeriod",
  // eslint-disable-next-line consistent-return
  async (values) => {
    try {
      message.loading("Сохранение файла экспорта...", 0);
      const response = axios.post(createByPeriodRoute(), values);
      const { data } = await response;
      const { status } = await response;
      message.destroy();
      Message("Отправка прошла успешно", status);
      return data;
    } catch (e) {
      message.destroy();
      Message("Ошибка отправки", e);
    }
  }
);

const handleDownloadFile = createAsyncThunk(
  "invoices/handleDownloadFile",
  // eslint-disable-next-line consistent-return
  async ({ periodFrom: dateFrom, periodTo: dateTo }) => {
    try {
      message.loading("Формирование файла экспорта, это может занять более 10 минут...", 0);
      const response = axios.get(
        [
          downLoadFileRoute(
            "invoices",
            `?periodFrom=${encodeURIComponent(dateFrom)}`,
            `&periodTo=${encodeURIComponent(dateTo)}`
          ),
        ].join(""),

        {
          responseType: "blob",
        }
      );
      const { data } = await response;
      const { status } = await response;
      message.destroy();
      Message("Файл успешно сформирован", status);
      saveAs(
        data,
        `Период ${dateFrom ? toDisplayFormat(dateFrom) : ""}-${
          dateTo ? toDisplayFormat(dateTo) : ""
        }.zip`
      );
    } catch (e) {
      message.destroy();
      Message("Ошибка", e);
    }
  }
);

const invoicesBulkCreate = createAsyncThunk(
  "invoices/invoicesBulkCreate",
  // eslint-disable-next-line consistent-return
  async (dataPost) => {
    try {
      message.loading("Создание инвойсов...", 0);
      const response = axios.post(invoicesBulkRoute(), dataPost);
      const { data } = await response;
      const { status } = await response;
      message.destroy();
      Message("Инвойсы созданы", status);
      return data;
    } catch (e) {
      message.destroy();
      Message("Ошибка создания инвойсов", e.response?.data?.message);
    }
  }
);

const createInvoices = createAsyncThunk("invoices/createInvoices", (bodyRequestArr) => {
  const url = createInvoiceRoute();
  message.loading("Создание инвойсов...", 0);
  return Promise.all(bodyRequestArr.map((createdInvoice) => axios.post(url, createdInvoice)))
    .then(() => {
      message.destroy();
      message.success("Инвойсы созданы");
    })
    .catch(() => {
      message.destroy();
      message.error({ content: "Ошибка создания инвойсов" });
    });
});

const slice = createSlice({
  name: "invoices",
  initialState,
  reducers: {},
  extraReducers: {
    [handleCreateByPeriod.pending]: (state) => {
      state.createByPeriodUpload = rtkRequestStatusCodes.pending;
    },
    [handleCreateByPeriod.fulfilled]: (state, action) => {
      state.createByPeriodUpload = action.payload?.data;
      state.createByPeriodUploadLoading = rtkRequestStatusCodes.fulfilled;
    },
    [handleCreateByPeriod.rejected]: (state) => {
      state.createByPeriodUploadLoading = rtkRequestStatusCodes.rejected;
    },

    [handleDownloadFile.pending]: (state) => {
      state.downloadFile = rtkRequestStatusCodes.pending;
    },
    [handleDownloadFile.fulfilled]: (state, action) => {
      state.downloadFile = action.payload?.data;
      state.downloadFileLoading = rtkRequestStatusCodes.fulfilled;
    },
    [handleDownloadFile.rejected]: (state) => {
      state.downloadFileLoading = rtkRequestStatusCodes.rejected;
    },
  },
});

const { reducer } = slice;

export {
  handleCreateByPeriod,
  handleDownloadFile,
  invoicesBulkCreate,
  deleteInvoices,
  createInvoices,
};
export default reducer;
